import { useQuery } from "@tanstack/react-query";
import { getConfigObject, useBaseData } from "../../../utils/utils";
import { ProviderGroupControllerApi } from "../../../services";
import { ProviderGroupDetails } from "../../../types/provider-types";

/**
 *
 * @author rajkumar rathod
 */
export const useProviderGroupProfile = (
  id?: string
): useBaseData<ProviderGroupDetails> =>
  useQuery({
    queryKey: ["provider-group-profile", id],
    enabled: id !== null || id !== undefined,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new ProviderGroupControllerApi(getConfigObject())
        .getProviderGroupById(id as string)
        .then((res) => res?.data?.data as ProviderGroupDetails),
  });
